import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class LayerForeground extends Phaser.Group {
  constructor({ game, data, width }) {
    super(game);

    this._width = width;

    this.tr = 0xff;
    this.tg = 0xff;
    this.tb = 0xff;

    for (let i = 0; i < data.parts.length; i++) {
      const part = data.parts[i];
      const img = this.game.make.image(part.x, this.game.height, data.asset, part.id);
      img.anchor.set(0, 1);
      this.add(img);
    }
  }

  get width() {
    return this._width;
  }

  setNight(instant) {
    const tint = NIGHT_TINT;
    const r = tint >> 16;
    const g = (tint >> 8) & 0x00ff;
    const b = tint & 0x0000ff;

    if (instant) {
      this.tr = r;
      this.tg = g;
      this.tb = b;
      this.updateTint();
    } else {
      this.game.add
        .tween(this)
        .to({ tr: r, tg: g, tb: b }, 500, null, true)
        .onUpdateCallback(this.updateTint, this);
    }
  }

  setDay() {
    const r = 0xff;
    const g = 0xff;
    const b = 0xff;

    this.game.add
      .tween(this)
      .to({ tr: r, tg: g, tb: b }, 500, null, true)
      .onUpdateCallback(this.updateTint, this);
  }

  updateTint(tween, value, tweenData) {
    tween;
    tweenData;
    value;
    const r = this.tr | 0;
    const g = this.tg | 0;
    const b = this.tb | 0;
    const tint = (r << 16) | (g << 8) | b;

    for (let i = 0; i < this.children.length; i++) {
      this.children[i].tint = tint;
    }
  }

  addObject(object) {
    this.addChild(object);
  }
}
